import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import { CertificationsContainer } from '@/components/custom';

const ViewDataCertifications = () => (
  <CertificationsContainer
    additionalCheckStatus={VerificationAdditionalCheckStatusEnum.WITH_STATE}
    disableActionInvalidations
    deniedStateChange />
);

export default ViewDataCertifications;
